import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type InterruptCleaningMissionDialogProps = {
  open: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => Promise<unknown>;
};

const InterruptCleaningMissionDialog = ({
  open,
  isPending,
  onClose,
  onConfirm,
}: InterruptCleaningMissionDialogProps) => {
  const { t } = useTranslation('environmental-cleaning');
  const [comment, setComment] = useState('');
  const canConfirm = comment.trim().length > 0 && !isPending;

  const confirm = async () => {
    await onConfirm(comment.trim());
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        <Typography variant="h2">{t('actions.interruptTitle')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Typography color="secondary">{t('actions.interruptHint')}</Typography>
          <TextField
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            label={t('actions.interruptComment')}
            multiline
            minRows={2}
            fullWidth
            autoFocus
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          {t('cancel', { ns: 'common' })}
        </Button>
        <Button color="error" onClick={confirm} disabled={!canConfirm}>
          {t('actions.interrupt')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InterruptCleaningMissionDialog;
